var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{class:_vm.className,attrs:{"lazy":"","fit":"cover","src":_vm.resolvedThumbUrl,"preview-src-list":_vm.list},on:{"load":_vm.loadSuccess}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon-picture-outline"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }